export enum LeaderboardTabKeys {
  LEADERBOARD = 'leaderboard',
  NEWBIES = 'newbies'
}
